module.exports = __webpack_public_path__ + "img/holeonice.11c910b7.jpg";